<template>
  <div>
    <dashboard-page-title :showSearch="false" :showFilter="false" :showMainActions="false" @addEvent="$router.push({name: 'addMerchant'})">
    إضافة تاجر
    </dashboard-page-title>
    <ValidationObserver ref="merchantForm" v-slot="{ handleSubmit, invalid }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <b-row>
          <b-col md="3" class="mb-3">
            <input-form
              placeholder="أدخل الاسم"
              label="الاسم الثلاثى"
              v-model="merchant.full_name"
              name="الاسم الثلاثى"
              validate="arabic_name"
            />
          </b-col>
          <b-col md="3" class="mb-3">
            <input-form
              type="email"
              placeholder="أدخل البريد الالكترونى"
              label="البريد الالكترونى"
              v-model="merchant.email"
              name="البريد الالكترونى"
              validate="required|email"
            />
          </b-col>
          <b-col md="3" class="mb-3">
            <input-form
              placeholder="رقم الهاتف"
              label="رقم الهاتف"
              v-model="merchant.phone"
              name="رقم الهاتف"
              validate="required|numeric|min:9|max:11"
            />
          </b-col>
          <b-col md="3" class="mb-3">
            <input-form
              placeholder="رقم الهوية"
              label="رقم الهوية"
              v-model="merchant.national_id"
              name="رقم الهوية"
              validate="required|digits:10"
            />
          </b-col>
          <b-col md="3" class="mb-3">
            <input-form
              placeholder="الاسم بالعربي"
              label="اسم المتجر باللغة العربية"
              v-model="merchant.ar_store_name"
              name="اسم المتجر بالعربية"
              validate="arabic_name"
            />
          </b-col>
          <b-col md="3" class="mb-3">
            <input-form
              placeholder="الاسم بالانجليزي"
              label="اسم المتجر باللغة الانجليزية"
              v-model="merchant.en_store_name"
              name="اسم المتجر بالإنجليزية"
              validate="english_name"
            />
          </b-col>
          <b-col md="3" class="mb-3">
            <input-form
              placeholder="عنوان المتجر"
              label="عنوان المتجر"
              v-model="merchant.store_address"
              name="عنوان المتجر"
              validate="required|min:5"
            />
          </b-col>
          <b-col md="3" class="mb-3">
            <select-form
              :options="cityOptions"
              label="المدينة"
              v-model="merchant.store_city"
              placeholder="اختر المدينة"
              name="المدينة"
              validate="required"
            />
          </b-col>
          <b-col cols="12">
            <b-row>
              <b-col cols="3">
                <b-button
                  variant="primary"
                  type="submit"
                  :disabled="invalid || loadingSubmit"
                  v-if="!loadingSubmit"
                >
                  اضافة تاجر
                </b-button>
                <b-button v-else variant="primary" class="text-white" disabled type="submit">
                  <spinner-loading text="loading"></spinner-loading>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import merchants from '../services/marketPlace'

import citiesAndCountriesMixin from '@/mixins/countriesAndCities'

export default {
  components: { },
  mixins: [citiesAndCountriesMixin],
  mounted () {
    core.index()
  },
  data () {
    return {
      loadingSubmit: false,
      merchant: {
        full_name: '',
        email: '',
        phone: '',
        national_id: '',
        ar_store_name: '',
        en_store_name: '',
        store_address: '',
        store_city: ''
      }
    }
  },
  computed: {
    cityOptions () {
      return (this.allCities || []).map(city => ({
        value: String(city.id),
        text: city.name
      }))
    }
  },
  methods: {
    trimFields () {
      const fields = [
        'full_name',
        'email',
        'phone',
        'national_id',
        'ar_store_name',
        'en_store_name',
        'store_address'
      ]
      fields.forEach(key => {
        this.merchant[key] = String(this.merchant[key] || '').trim()
      })
    },
    async onSubmit () {
      this.trimFields()
      await this.$nextTick()
      const isValid = await this.$refs.merchantForm.validate()
      if (!isValid) {
        return
      }
      this.loadingSubmit = true
      merchants.addMerchent(this.merchant).then(res => {
        core.showSnackbar('success', 'تم اضافة تاجر')
        this.loadingSubmit = false
        this.$refs.merchantForm.reset()
        Object.keys(this.merchant).forEach(key => {
          this.merchant[key] = ''
        })
      }).catch(() => {
        this.loadingSubmit = false
      })
    }
  }
}
</script>
